import { normalizeRoadmapLanguageKey, formatLanguageDisplay } from '../../utils/roadmapDisplay';

export const PLAYGROUND_LANGUAGES = [
  'javascript',
  'python',
  'typescript',
  'java',
  'cpp',
  'csharp',
  'ruby',
  'go',
  'rust',
  'php',
  'swift',
  'kotlin',
  'sql',
  'shell',
];

const EXTENSION_BY_LANG = Object.freeze({
  javascript: 'js',
  typescript: 'ts',
  python: 'py',
  java: 'java',
  cpp: 'cpp',
  csharp: 'cs',
  ruby: 'rb',
  go: 'go',
  rust: 'rs',
  php: 'php',
  swift: 'swift',
  kotlin: 'kt',
  sql: 'sql',
  shell: 'sh',
});

export function normalizePlaygroundLanguage(lang) {
  const key = normalizeRoadmapLanguageKey(lang);
  if (!key) return 'javascript';
  if (key === 'html/css' || key === 'html') return 'html';
  return key;
}

export function buildPlaygroundLanguageOptions(userLanguages = []) {
  const seen = new Set();
  const options = [];

  const addOption = (raw) => {
    const value = normalizePlaygroundLanguage(raw);
    if (!value || seen.has(value)) return;
    seen.add(value);
    options.push({
      value,
      label: formatLanguageDisplay(value),
    });
  };

  userLanguages.forEach(addOption);
  PLAYGROUND_LANGUAGES.forEach(addOption);

  return options;
}

export function getPlaygroundFilename(languageKey) {
  const key = normalizePlaygroundLanguage(languageKey);
  const ext = EXTENSION_BY_LANG[key] || 'txt';
  return `main.${ext}`;
}

export function playgroundCodeStorageKey(userId, languageKey) {
  return `${userId}_playground_code_${normalizePlaygroundLanguage(languageKey)}`;
}

export const PLAYGROUND_LANGUAGE_STORAGE_SUFFIX = '_playground_language';
